export const m4l0Solution = `// do not modify code on this line or above

fn bigger(a: usize, b: usize) -> usize {
    if a > b {
        return a;
    }
    return b;
}

// do not modify code on this line or below

// Don't mind this for now :)
mod tests {
    use super::bigger;

    #[test]
    fn ten_is_bigger_than_eight() {
        assert(10_usize == bigger(10_usize, 8_usize), '10 bigger than 8');
    }

    #[test]
    fn fortytwo_is_bigger_than_thirtytwo() {
        assert(42_usize == bigger(32_usize, 42_usize), '42 bigger than 32');
    }
}`;
